// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fixed-site-flow {
   position: relative;
   top: 5px;
   height: auto;
   min-height: 30px;
}
`, "",{"version":3,"sources":["webpack://./src/app/e-signature/main-site-flow/main-site-flow.component.css"],"names":[],"mappings":"AAAA;GACG,kBAAkB;GAClB,QAAQ;GACR,YAAY;GACZ,gBAAgB;AACnB","sourcesContent":[".fixed-site-flow {\n   position: relative;\n   top: 5px;\n   height: auto;\n   min-height: 30px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
